import { merge, Observable, Subject } from 'rxjs';
import { setDiffRoutine } from 'scope/stateRoutines';
import { scopeDiff$ } from 'scope/scopeDiff$';
import { catchError } from 'rxjs/operators';
import { logError } from '@ardoq/logging';

const error$ = new Subject<any>();

type CreateRoutinesStreamsTuple = [
  (...args: Observable<any>[]) => Observable<any>,
  Observable<any>[],
];

const getStateRoutines = () => {
  const routines: CreateRoutinesStreamsTuple[] = [
    [setDiffRoutine, [scopeDiff$]],
  ] as CreateRoutinesStreamsTuple[];

  return merge(
    ...routines.map(([getRoutine, streams]) => getRoutine(...streams))
  );
};

const subscribeStateRoutine = (
  stateRoutineToSubscribe: Observable<unknown>,
  errorSubject: Subject<any>
) =>
  stateRoutineToSubscribe
    .pipe(
      catchError((err, stream) => {
        errorSubject.next(err);
        return stream;
      })
    )
    .subscribe();

export function startStateRoutines() {
  const stateRoutineSubscription = subscribeStateRoutine(
    getStateRoutines(),
    error$
  );
  const errorSubscription = error$.subscribe(error =>
    logError(error, 'State routine error')
  );

  if (module.hot) {
    module.hot.dispose(() => {
      stateRoutineSubscription.unsubscribe();
      errorSubscription.unsubscribe();
    });
  }
}
